import { useState } from 'react';
import { Link } from '#components/atoms/link/Link.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import { useAppLocation } from '#hooks/useAppLocation.ts';
import { DeleteDomainDialog } from './DeleteDomainDialog.tsx';

type Props = {
  domainId: string;
  domainName: string;
  isVerified: boolean;
};

export function DomainActionMenu({ domainId, isVerified, domainName }: Props) {
  const location = useAppLocation();
  const [domainBeingDeletedId, setDomainBeingDeletedId] = useState<string | null>(null);

  return (
    <>
      <MeatballMenu>
        {!isVerified ?
          <MenuItem render={<Link to={`/settings/sso/domains/${domainId}/verify`} state={{ from: location }} />}>
            Verify
          </MenuItem>
        : null}
        <MenuItem
          render={
            <Link
              to={{
                pathname: '/settings/sso/add',
                search: `?domainId=${domainId}`,
              }}
              state={{ from: location }}
            />
          }
        >
          Add provider
        </MenuItem>
        <MenuItem onClick={() => setDomainBeingDeletedId(domainId)}>Delete</MenuItem>
      </MeatballMenu>
      {domainBeingDeletedId ?
        <DeleteDomainDialog
          domainId={domainBeingDeletedId}
          domainName={domainName}
          isVerified={isVerified}
          onDelete={() => {
            setDomainBeingDeletedId(null);
          }}
          onCancel={() => {
            setDomainBeingDeletedId(null);
          }}
        />
      : null}
    </>
  );
}
